import { z } from "zod";

/**
 * Yol (path) parametresi UUID şemaları (güvenlik/dayanıklılık denetimi bulgusu).
 *
 * ### Neden var
 *
 * `requireTenant` `x-tenant-id`'yi DB'ye vermeden önce UUID biçimini doğruluyor ve
 * gerekçesi açık: bozuk bir değer `uuid` kolonuna gidince Postgres `22P02` ile patlar —
 * kullanıcı girdisiyle tetiklenen bir **500** doğar (yanlış alarm) ve saldırgan 500/404
 * farkından geçerli kimlik biçimini öğrenir. Aynı koruma İKİNCİL path parametrelerinde
 * (membershipId, inviteId, roles/files/device `:id`) yoktu; bu şemalar onu `validate()`
 * ile her uca taşıyor. Bozuk biçim artık DB'ye hiç gitmeden 422 döner.
 *
 * ⚠ `validate()` params şemasını `.strict()`'liyor: şema o rotanın TÜM path
 * parametrelerini içermeli (fazlası reddedilir, eksiği "zorunlu" hatası verir). Bu yüzden
 * tenant alt-kaynak rotalarında `id` (tenant) DE tanımlı — `requireTenant` onu ayrıca
 * doğrulasa bile `c.req.param()` onu da döndürüyor.
 */
const uuid = z.uuid("Geçersiz kimlik biçimi");

/** Tek `:id` parametresi (files, roles, session/devices). */
export const idParamSchema = z.object({ id: uuid });

/** Tenant alt-kaynağı: `:id` (tenant) + `:membershipId`. */
export const membershipParamsSchema = z.object({ id: uuid, membershipId: uuid });

/** Tenant alt-kaynağı: `:id` (tenant) + `:inviteId`. */
export const inviteParamsSchema = z.object({ id: uuid, inviteId: uuid });
